import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../firebase";

/**
 * Registra un evento de producto (funnel de onboarding, seguridad) en la
 * colección `analytics_events`, para los tableros — Fase 6 del onboarding
 * (spec de eventos en docs/onboarding/04-METRICAS.md).
 *
 * Fire-and-forget: NO se espera (`await`) y nunca bloquea ni rompe el flujo
 * principal; si falla la escritura, solo se loguea en consola.
 *
 * Nombres de evento (exactos): invitation_sent, activation_link_opened,
 * password_created, activation_completed, password_changed,
 * onboarding_step_completed, support_call_requested, etc.
 *
 * @param {string} name - Nombre exacto del evento.
 * @param {Object} [payload] - Propiedades tipadas (canal, paso, templateKey…).
 */
export function logEvent(name, payload = {}) {
  try {
    addDoc(collection(db, "analytics_events"), {
      name,
      ...payload,
      uid: auth.currentUser?.uid || null,
      email: auth.currentUser?.email || null,
      at: serverTimestamp(),
    }).catch((e) => console.warn("[analytics] no se pudo registrar", name, e?.message));
  } catch (e) {
    console.warn("[analytics] error", name, e?.message);
  }
}
